import React from 'react'; 
import './Aparna-Banerjee.css'; 
import '../Artists/Artists.css'; 
import Navbar from '../../Navbar/Navbar'; 
import '../../Button.css'; 

function AparnaBanerjee() {

  window.scrollTo(0, 0)

    return (
      <>
          
          <div className="artist-section"> 

          <form method="get" action="#/aparna-banerjee-mandarin"> 
            <button id="the-button" type='btn'>普通話</button> 
          </form> 

            {/* Artist Name */} 

            <h1 className="artist">Aparna Banerjee</h1>
            <hr /> 

            {/* Artist Summary */}

            <p id="art-paragraph">
              The work of the outstanding Indian female artist Aparna Banerjee 
              perfectly combines Eastern traditional art with Western modern genre. 
              In her paintings, she can trace the footprints of contemporary genre 
              masters and the Dunhuang aftertaste!  The source is naturally the 
              traditional Buddhist culture of India!
              </p>

              {/* List of Paintings [Computer] */} 

              <div className="the-paintings">
              <img src="./beauty_1.jpeg" id="painting-ab"></img> 
              <img src="./beauty_2.jpeg" id="painting-ab"></img> 
              </div>

              <div className="the-words">
              <h5 id="caption-ab-1">Recollect</h5>
              <h5 id="caption-ab-2">The Mask</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">22” x 30” [Framed]</h5> 
              <h5 id="caption-ab-22">22” x 30” [Framed]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5> 
              <h5 id="caption-ab-22">Acrylic on Paper</h5> 
              </div>

              <div className="the-paintings">
              <img src="./AB3.jpeg" id="painting-ab"></img> 
              <img src="./AB4.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">Who Am I?</h5>
              <h5 id="caption-ab-2">Spirit</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">22” x 30” [No Frame]</h5> 
              <h5 id="caption-ab-22">22” x 30” [No Frame]</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./pp.png" id="painting-ab-sold"></img>   
              <img src="./AB6.jpeg" id="painting-ab"></img> 
              </div>

              <div className="the-words">
              <h5 id="caption-ab-1">Lost Cat</h5>
              <h5 id="caption-ab-2">Lost in Space</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">22” x 30” [No Frame]</h5>
              <h5 id="caption-ab-22">22” x 30” [No Frame]</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./AB7.jpeg" id="painting-ab"></img> 
              <img src="./AB8.jpeg" id="painting-ab"></img> 
              </div>

              <div className="the-words">
              <h5 id="caption-ab-1">Why?</h5>
              <h5 id="caption-ab-2">Windy</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">22” x 30” [Framed]</h5> 
              <h5 id="caption-ab-22">15” x 22” [Framed]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./AB9.jpeg" id="painting-ab"></img> 
              <img src="./AB10.png" id="painting-ab-sold"></img> 
              </div>

              <div className="the-words">
              <h5 id="caption-ab-1">Red</h5> 
              <h5 id="caption-ab-2">Yellow</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">15” x 22” [Framed]</h5> 
              <h5 id="caption-ab-22">15” x 22” [Framed]</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./AB11.jpeg" id="painting-ab"></img> 
              <img src="./AB12.jpeg" id="painting-ab"></img> 
              </div>

              <div className="the-words">
              <h5 id="caption-ab-1">Blue</h5>
              <h5 id="caption-ab-2">Note</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">15” x 22” [Framed]</h5>
              <h5 id="caption-ab-22">15” x 22” [Framed]</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./AB13.jpeg" id="painting-ab"></img> 
              <img src="./AB14.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">You Think</h5>
              <h5 id="caption-ab-2">Maybe</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">15” x 22” [Framed]</h5> 
              <h5 id="caption-ab-22">15” x 22” [Framed]</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5> 
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./AB15.jpeg" id="painting-ab"></img> 
              <img src="./AB16.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">Tatto Girl</h5>
              <h5 id="caption-ab-2">Flower Shower</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">15” x 22” [Framed]</h5>
              <h5 id="caption-ab-22">22” x 30” [No Frame]</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5>
              </div>

              <div className="the-paintings">
              <img src="./AB17.jpeg" id="painting-ab"></img> 
              <img src="./AB18.jpeg" id="painting-ab"></img> 
              </div>

              <div className="the-words">
              <h5 id="caption-ab-1">Simple</h5> 
              <h5 id="caption-ab-2">Huggy Bear</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">15” x 22” [Framed]</h5> 
              <h5 id="caption-ab-22">22” x 30” [No Frame]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Acrylic on Paper</h5>
              <h5 id="caption-ab-22">Acrylic on Paper</h5> 
              </div>

              <div className="the-paintings">
              <img src="./F1.jpeg" id="painting-ab"></img> 
              <img src="./F2.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">Blooming Beauty</h5>
              <h5 id="caption-ab-2">Pond Flowers</h5>
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">33” x 46” [No Frame]</h5> 
              <h5 id="caption-ab-22">46” X 53” [No Frame]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Oil on Canvas</h5>
              <h5 id="caption-ab-22">Oil on Canvas</h5> 
              </div>

              <div className="the-paintings">
              <img src="./F3.jpeg" id="painting-ab"></img> 
              <img src="./F4.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">Raindrops</h5>
              <h5 id="caption-ab-2">Gorgeous</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">36” x 47” [No Frame]</h5> 
              <h5 id="caption-ab-22">29” x 46” [No Frame]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Oil on Canvas</h5>
              <h5 id="caption-ab-22">Oil on Canvas</h5>
              </div>

              <div className="the-paintings">
              <img src="./F5.jpeg" id="painting-ab"></img> 
              <img src="./F6.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">Beautiful</h5>
              <h5 id="caption-ab-2">Flowers in the Storm</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">30” x 48” [No Frame]</h5> 
              <h5 id="caption-ab-22">30" x 48” [No Frame]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Oil on Canvas</h5>
              <h5 id="caption-ab-22">Oil on Canvas</h5>
              </div>

              <div className="the-paintings">
              <img src="./F7.jpeg" id="painting-ab"></img> 
              <img src="./Maiden-in-Color.jpeg" id="painting-ab"></img> 
              </div> 

              <div className="the-words">
              <h5 id="caption-ab-1">Perfect</h5>
              <h5 id="caption-ab-2">Noble Woman</h5> 
              </div> 
              <div className="the-words">
              <h5 id="caption-ab-11">29” x 46” [No Frame]</h5> 
              <h5 id="caption-ab-22">36” x 47” [No Frame]</h5> 
              </div>
              <div className="the-words">
              <h5 id="caption-ab-11">Oil on Canvas</h5>
              <h5 id="caption-ab-22">Oil on Canvas</h5> 
              </div>

              {/* List of Paintings [Phone] */} 

              <img src="./beauty_1.jpeg" id="image-mobile"/>
              <h5 id="caption-mobile">Recollect</h5> 
              <h5 id="caption-mobile">22” x 30” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/> 

              <img id="image-mobile" src="./beauty_2.jpeg"/>
              <h5 id="caption-mobile">The Mask</h5> 
              <h5 id="caption-mobile">22” x 30” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB3.jpeg"/>
              <h5 id="caption-mobile">Who Am I?</h5> 
              <h5 id="caption-mobile">22” x 30” [No Frame]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB4.jpeg"/>
              <h5 id="caption-mobile">Spirit</h5> 
              <h5 id="caption-mobile">22” x 30” [No Frame]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile-sold" src="./pp.png"/> 
              <h5 id="caption-mobile">Lost Cat</h5> 
              <h5 id="caption-mobile">22” x 30” [No Frame]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB6.jpeg"/>
              <h5 id="caption-mobile">Lost in Space</h5> 
              <h5 id="caption-mobile">22” x 30” [No Frame]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB7.jpeg"/>
              <h5 id="caption-mobile">Why?</h5> 
              <h5 id="caption-mobile">22” x 30” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB8.jpeg"/>
              <h5 id="caption-mobile">Windy</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB9.jpeg"/>
              <h5 id="caption-mobile">Red</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB10.png"/>
              <h5 id="caption-mobile">Yellow</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB11.jpeg"/>
              <h5 id="caption-mobile">Blue</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB12.jpeg"/>
              <h5 id="caption-mobile">Note</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB13.jpeg"/>
              <h5 id="caption-mobile">You Think</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB14.jpeg"/>
              <h5 id="caption-mobile">Maybe</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB15.jpeg"/>
              <h5 id="caption-mobile">Tattoo Girl</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB16.jpeg"/>
              <h5 id="caption-mobile">Flower Shower</h5> 
              <h5 id="caption-mobile">22” x 30” [No Frame]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB17.jpeg"/>
              <h5 id="caption-mobile">Simple</h5> 
              <h5 id="caption-mobile">15” x 22” [Framed]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./AB18.jpeg"/>
              <h5 id="caption-mobile">Huggy Bear</h5> 
              <h5 id="caption-mobile">22” x 30” [No Frame]</h5> 
              <h5 id="caption-mobile">Acrylic on Paper</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F1.jpeg"/>
              <h5 id="caption-mobile">Blooming Beauty</h5> 
              <h5 id="caption-mobile">33” x 46” [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F2.jpeg"/>
              <h5 id="caption-mobile">Pond Flowers</h5> 
              <h5 id="caption-mobile">46" x 53" [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F3.jpeg"/>
              <h5 id="caption-mobile">Raindrops</h5> 
              <h5 id="caption-mobile">36” x 47” [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F4.jpeg"/>
              <h5 id="caption-mobile">Gorgeous</h5> 
              <h5 id="caption-mobile">29" x 46" [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5>  

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F5.jpeg"/>
              <h5 id="caption-mobile">Beautiful</h5> 
              <h5 id="caption-mobile">30” x 48” [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F6.jpeg"/>
              <h5 id="caption-mobile">Flowers in the Storm</h5> 
              <h5 id="caption-mobile">30” x 48” [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5> 

              <br id="only-mobile"/>

              <img id="image-mobile" src="./F7.jpeg"/>
              <h5 id="caption-mobile">Perfect</h5> 
              <h5 id="caption-mobile">29” x 46” [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5> 

              <br id="only-mobile"/> 

              <img id="image-mobile" src="./Maiden-in-Color.jpeg"/>
              <h5 id="caption-mobile">Noble Woman</h5> 
              <h5 id="caption-mobile">36” x 47” [No Frame]</h5> 
              <h5 id="caption-mobile">Oil on Canvas</h5> 

              <br /> 

          </div> 
          </> 
    );
  }
  
  export default AparnaBanerjee;